<template>
  <block-blank-form
    submit-label="Сохранить"
    v-bind="$attrs"
    form-type="edit"
    :errors="errors"
    @submit="processBlockForm"
  />
</template>

<script>
import helpers from '@/helpers'
import { updateBlock } from '@/services/block.service'
import blockBlankForm from '@/components/forms/block/BlockBlankForm'

export default {
  name: 'block-edit-form',
  components: { blockBlankForm },
  inheritAttrs: false,
  data () {
    return {
      errors: {
        block: {
          id: [],
          number: [],
          building: []
        },
        non_field_errors: []
      }
    }
  },
  methods: {
    fillErrors: helpers.fillErrors,

    processBlockForm () {
      this.updateBlock().then((success) => {
        if (success) {
          this.showMsg('Информация о подъезде была успешно обновлена!', 'success', 'Успешно')
          this.$emit('after', true)
        } else {
          this.$emit('after', false)
        }
      })
    },
    updateBlock () {
      return updateBlock(this.$attrs.block).then((response) => {
        this.fillErrors(this.errors.block, {})
        return true
      }).catch(err => {
        this.fillErrors(this.errors.block, err.response.data)

        if (this.errors.non_field_errors[0]) {
          this.$parent.$parent.showPopupMsg(this.errors.non_field_errors[0], 'error')
        }

        return false
      })
    },
    showMsg (text, type, title) {
      let foundRoot = false
      let $parent = this.$parent

      while (!foundRoot) {
        console.log($parent)
        if ($parent.$parent.$parent === undefined) {
          foundRoot = true
          $parent.showPopupMsg(text, type, title)
        } else {
          $parent = $parent.$parent
        }
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// BlockEditForm.vue?a5f0fb18